var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "Section mb-5"
  }, [_vm.title ? _c('section-title', [_vm._v(" " + _vm._s(_vm.title) + " ")]) : _vm._e(), _vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }